export enum DashboardGraphColorMappingEnum {
  SINGLE_COLOR = "SINGLE_COLOR",
  TWO_COLORS_WITH_CONDITION = "TWO_COLORS_WITH_CONDITION",
  DIFFERENT_COLORS = "DIFFERENT_COLORS",
  DIFFERENT_COLORS_WITH_CONDITION = "DIFFERENT_COLORS_WITH_CONDITION",
  NONE = "NONE",
}
